<div class="bg-white rounded">
  <p-table
    #dt
    [value]="data"
    [paginator]="true"
    [rows]="rows"
    [lazy]="lazy"
    [totalRecords]="totalRecordss"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="globalFilterFields"
    dataKey="id"
    (onLazyLoad)="lazyLoad($event)"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'PAGINATION_REPORT' | translate"
    [rowHover]="true"
  >
    <!-- filters -->
    <ng-template pTemplate="caption" *ngIf="showSearch" >
      <div class="filters">
        <p-button
          [label]="'clear' | translate"
          icon="pi pi-filter-slash"
          class="clear-btn"
          [outlined]="true"
          (onClick)="clearSearch()"
        ></p-button>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchValue"
            (input)="handleSearch()"
            [placeholder]="'searchPlaceholder' | translate"
            class="search-input"
          />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <!-- <th>
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
        <!-- <th *ngFor="let col of columns" pSortableColumn="{{ col.field }}"
            [style.width]="col.width || 'auto'"
            [style.text-align]="col.align || 'center'">
          <div class="custom-table-header">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
            <p-columnFilter
              type="text"
              [field]="col.field"
              display="menu"
              class="ml-auto"
            ></p-columnFilter>
          </div>
        </th> -->
        <th *ngFor="let col of columns" pSortableColumn="{{ col.field }}">
          <div class="custom-table-header">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
        <th
          *ngIf="showDetails || showEdit || showDelete || customAction"
          style="text-align: center"
        >
          {{ "ACTIONS" | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <!-- <td><p-tableCheckbox [value]="row"></p-tableCheckbox></td> -->
        <td
          *ngFor="let col of columns; let i = index"
          [ngClass]="{
            'id-column': col.field === 'applicantId',
            'company-column': col.field === 'companyName',
            'amount-column': col.field === 'requestAmount',
            'date-column': col.field === 'creationDate',
            'status-column': col.field === 'status',
            'notes-column': col.field === 'notes'
          }"
        >
          <span *ngIf="col.field === 'requestAmount'" class="amount-value">
            {{ row[col.field] | roundNumber | number:'1.0-0' }} SAR
          </span>
        <span *ngIf="col.field === 'creationDate'" class="date-value">
  {{
    (row[col.field] | fixAnyDate | date: "dd/MM/yyyy") ||
      row[col.field] ||
      "No date"
  }}
</span>
          <span
            *ngIf="col.field === 'status'"
            [ngClass]="'status-' + (row.statusKey || row[col.field] || '').toLowerCase()"
          >
            {{ row[col.field] }}
          </span>
          <span
            *ngIf="col.field === 'notes'"
            [ngClass]="row[col.field] ? 'notes-value' : 'notes-empty'"
          >
            {{ row[col.field] || ("NO_NOTES_AVAILABLE" | translate) }}
          </span>
          <span
            *ngIf="
              col.field !== 'requestAmount' &&
              col.field !== 'creationDate' &&
              col.field !== 'status' &&
              col.field !== 'notes'
            "
          >
            {{ row[col.field] }}
          </span>
        </td>
        <td
          *ngIf="showDetails || showEdit || showDelete || customAction"
          class="actions"
          style="text-align: center; vertical-align: middle"
        >
          <div class="action-container">
            <ng-container *ngIf="customAction">
              <div class="custom-action-wrapper">
                <ng-container
                  *ngTemplateOutlet="customAction; context: { $implicit: row }"
                ></ng-container>
              </div>
            </ng-container>

            <div
              class="default-actions"
              *ngIf="showDetails || showEdit || showDelete"
            >
              <button
                *ngIf="showDetails"
                pButton
                icon="pi pi-eye"
                class="action p-button-info p-button-rounded"
                (click)="details(row)"
                [title]="'DETAILS' | translate"
              ></button>
              <button
                *ngIf="showEdit"
                pButton
                icon="pi pi-pencil"
                class="action p-button-warning p-button-rounded"
                (click)="edit(row)"
                [title]="'EDIT' | translate"
              ></button>
              <button
                *ngIf="showDelete"
                pButton
                icon="pi pi-trash"
                class="action p-button-danger p-button-rounded"
                (click)="delete(row)"
                [title]="'DELETE' | translate"
              ></button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 1" class="text-center">
          {{ "NO_RECORDS_FOUND" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
